
import usePrintDefinition from './usePrintDefinition';

import { getReportDefinition } from '../reducers/definition';

export default function useReportDefinition() {
    const printDefinition = usePrintDefinition();
    const reportDefinition = getReportDefinition(printDefinition);
    return reportDefinition;
}
